/* eslint-disable react/prop-types */
import { useEffect, useMemo, useState } from "react";
import {Button, Col, Form, Modal, Row} from "react-bootstrap";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import PaymentOrderService from "../../service/payment-order-service";
import PartyService from "../../service/party-service";
import BankAccountService from "../../service/bank-account-service";
import Pasoonate from "pasoonate";
import NumberInput from "../components/NumberInput";

const paymentOrderService = new PaymentOrderService();
const partyService = new PartyService();
const bankAccountService = new BankAccountService();
const today = Pasoonate.make().jalali().getDate();

await loadDictionary('payment-order-create-window');

function CreatePaymentOrderWindow({isOpenWindow, onCloseWindow}) {
  const [partyId, setPartyId] = useState(0);
  const [partyBankAccountId, setPartyBankAccountId] = useState(0);
  const [amount, setAmount] = useState();
  const [dueDateYear, setDueDateYear] = useState(today.year);
  const [dueDateMonth, setDueDateMonth] = useState(today.month);
  const [dueDateDay, setDueDateDay] = useState(today.day);
  const [description, setDescription] = useState('');
  const [parties, setParties] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const dayOptions = useMemo(() => {
    const options = [];

    for(let i = 1; i <= 31; i++) {
      options.push(<option key={i} value={i}>{i}</option>);
    }

    return options;
  }, []);
  const monthOptions = useMemo(() => {
    const options = [];

    for(let i = 1; i <= 12; i++) {
      options.push(<option key={i} value={i}>{i}</option>);
    }

    return options;
  }, []);
  const yearOptions = useMemo(() => {
    const options = [];

    for(let i = 1405; i <= 1406; i++) {
      options.push(<option key={i} value={i}>{i}</option>);
    }

    return options;
  }, []);

  const handleClose = () => { 
    setPartyId(0);
    setPartyBankAccountId(0);
    setAmount(0);
    setDueDateYear(null);
    setDueDateMonth(null);
    setDueDateDay(null);
    setDescription('');
    onCloseWindow();
  };
  
  const handleSubmit = () => {
    const dueDate = Pasoonate.make().jalali().setDate(dueDateYear, dueDateMonth, dueDateDay);

    const paymentOrder = {
      party_id: parseInt(partyId),
      party_bank_account_id: parseInt(partyBankAccountId),
      amount: amount,
      due_date: dueDate.gregorian().format("yyyy-MM-dd"),
      description: description
    };

    paymentOrderService.create(paymentOrder).then(result => {
      if(result) {
        handleClose();
      }
    }).catch(error => {
      console.error(error);
    })
  }

  useEffect(() => {
    if(isOpenWindow) {
      partyService.findAll().then(parties => {
        const options = parties.map((party) => <option key={party.id} value={party.id}>{party.name}</option>);
        options.unshift(<option key={0} value={0}>{i18n.t("payment-order-create-window.choose_item")}</option>);

        setParties(options);
      });
    }
  }, [isOpenWindow]);

  useEffect(() => {
    if(Number(partyId)) {
      bankAccountService.findAllByPartyId(partyId).then(bankAccounts => {
        const options = bankAccounts.map((bankAccount) => <option key={bankAccount.id} value={bankAccount.id}>{bankAccount.name}</option>);
        setBankAccounts(options);
        setPartyBankAccountId(bankAccounts[0].id);
      });
    } else {
      (async () => {
        setBankAccounts([<option key={0} value={0}>{i18n.t("payment-order-create-window.choose_party")}</option>]);
        setPartyBankAccountId(0);
      })();
    }
  }, [partyId]);

  return (
    <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t("payment-order-create-window.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form method="POST" id="CreateForm" onSubmit={e => {e.preventDefault(); handleSubmit()}}>
          <Form.Group className="mb-3" controlId="">
            <Form.Label>{i18n.t("payment-order-create-window.party")}</Form.Label>
            <Form.Select autoFocus value={partyId} onChange={e => {setPartyId(e.target.value)}}>
              {parties}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3" controlId="">
            <Form.Label>{i18n.t("payment-order-create-window.party_bank_account")}</Form.Label>
            <Form.Select value={partyBankAccountId} onChange={e => {setPartyBankAccountId(e.target.value)}}>
              {bankAccounts}
            </Form.Select>
          </Form.Group>
          <NumberInput className="mb-3" label={i18n.t("payment-order-create-window.amount")} value={amount} onChange={setAmount} />
          <Row className="mb-3">
            <Form.Group as={Col} controlId="">
              <Form.Label>{i18n.t("payment-order-create-window.due_date_day")}</Form.Label>
              <Form.Select value={dueDateDay} onChange={e => {setDueDateDay(e.target.value)}}>
                {dayOptions}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} controlId="">
              <Form.Label>{i18n.t("payment-order-create-window.due_date_month")}</Form.Label>
              <Form.Select value={dueDateMonth} onChange={e => {setDueDateMonth(e.target.value)}}>
                {monthOptions}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} controlId="">
              <Form.Label>{i18n.t("payment-order-create-window.due_date_year")}</Form.Label>
              <Form.Select value={dueDateYear} onChange={e => {setDueDateYear(e.target.value)}}>
                {yearOptions}
              </Form.Select>
            </Form.Group>
          </Row>
          <Form.Group className="mb-3" controlId="">
            <Form.Label>{i18n.t("payment-order-create-window.description")}</Form.Label>
            <Form.Control type="text" value={description} onChange={e => {setDescription(e.target.value)}} />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>{i18n.t("payment-order-create-window.cancel_button")}</Button>
        <Button variant="primary" type="submit" form="CreateForm" >{i18n.t("payment-order-create-window.create_button")}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CreatePaymentOrderWindow;